import {useEffect, useReducer} from "react";
import useMountedRef from "./useMountedRef";


const useSequentialFileUploader = (uploadHandler) => {
    const [state, updateState] = useReducer(
        (oldState, partialState) => ({...oldState, ...partialState}),
        {
            isUploading: false,
            index: 0,
            files: [],
        }
    )
    const mounted = useMountedRef();

    useEffect(
        () => {
            const uploadFirstFile = async () => {
                if (state.index < state.files.length) {
                    updateState({isUploading: true});

                    await uploadHandler(state.files[state.index]);

                    if(mounted.current){
                        updateState({isUploading: false, index: state.index + 1});
                    }
                }
            }

            if (state.files.length > 0 && !state.isUploading) {
                uploadFirstFile();
            }
        },
        [state, mounted, uploadHandler]
    )

    const appendFiles = (files) => {
        updateState({files: [...state.files, ...files]})
    }

    return {
        uploadingFile: state.index < state.files.length ? state.files[state.index] : null,
        remainingFiles: state.files.filter((item, i) => i > state.index),
        appendFiles}
}

export default useSequentialFileUploader;